import { ImageShape } from '../../ImageGallery.types';
import { DEFAULT_IMAGE_RATIOS } from '../ImageGalleryGrid.constants';

/**
 * Finds the closest matching image shape based on the aspect ratio.
 *
 * Compares the input aspect ratio to a set of target aspect ratios (default or custom)
 * and returns the shape with the closest ratio.
 *
 * @param aspectRatio - The aspect ratio (width / height) of the image
 * @param targetRatios - Optional map of ImageShape to target aspect ratios (defaults to DEFAULT_IMAGE_RATIOS)
 * @returns The ImageShape whose target aspect ratio is closest to the input aspect ratio
 */
export function getClosestImageShape(aspectRatio: number, targetRatios = DEFAULT_IMAGE_RATIOS): ImageShape {
    return (Object.entries(targetRatios) as [ImageShape, number][]).reduce((closestShape, [shape, ratio]) => {
        const currentDistance = Math.abs(aspectRatio - ratio);
        const closestDistance = Math.abs(aspectRatio - targetRatios[closestShape]);
        return currentDistance < closestDistance ? shape : closestShape;
    }, 'square' as ImageShape);
}
